import React from "react";
import { Typography } from "Components/atoms/Typography";
import { ExpandedFlightButtonProps } from "./types";
import { ButtonContainer } from "./styles";

export const ExpandedFlightButton: React.FC<ExpandedFlightButtonProps> = ({
  sellersCount,
  onClick,
}) => {
  const hasSingleSeller = sellersCount === 1;

  return (
    <ButtonContainer onClick={onClick}>
      <Typography variant="body" weight="semiBold" color="mediumBlue">
        {hasSingleSeller
          ? "VER OUTRO 1 VENDEDOR"
          : `VER OUTROS ${sellersCount} VENDEDORES`}
      </Typography>
    </ButtonContainer>
  );
};
